import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import { ResourceService } from './services/ResourceService';
import { utility } from './common/utility';
import { AccountService } from './services/AccountService';
import { CookieService } from 'ngx-cookie-service';

declare var preFrameworkCookieFunctions: any;

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer p-d-flex p-ai-center p-p-4 p-shadow-2">
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12" *ngIf="showCookiePolicy" style="font-size: 16px;">                
                        We've updated our policies, by continuing to use this application, you agree to the use of cookies and similar tracking technologies described in our
                        <p-button label="Cookie Notice" styleClass="p-button-link" (click)="showPolicy(3)"></p-button>                                   
                    </div>
                    <div class="p-col-12 p-lg-5 p-md-4"></div>
                    <div class="p-col-12 p-lg-2 p-md-4" *ngIf="showCookiePolicy">
                         <p-button styleClass="fullwidthbtn" label="I agree" (click)="agreeCookiePolicy()"></p-button>
                    </div>
                    <div class="p-col-12 p-lg-5 p-md-4"></div>
                    <div class="p-col-12" style="text-align: center; width: 100%;">
                        <p>© {{currentYear}} All Rights Reserved. NAI Global</p>           
                    </div>       
                </div>               
            </div>           
        </div>        
    `
})
export class AppFooterComponent implements OnInit {
    currentYear: number;
    constructor(public app: AppComponent,
        private resourceService: ResourceService,
        private accountService: AccountService,
        public cookieService: CookieService) {
    }
    showTermsOfService: boolean = false;
    showCookiePolicy: boolean = false;
    showPrivacyPolicy: boolean = false;
    currentUser: any;
    userAgreements: any;

    ngOnInit() {
        this.currentYear = (new Date()).getFullYear();
        this.currentUser = this.accountService.userValue;
        this.showCookiePolicy = !preFrameworkCookieFunctions.hasAgreedToCookiePolicy();
        if (this.accountService.isLoggedIn() && this.accountService.user != null) {
            this.getUserAgreements(this.currentUser);
        } 

        this.accountService.appFooterGetAgreementsObservable.subscribe((res) => {
            this.getUserAgreements(res);
            }
        );
    }

    showPolicy(policyTypeId) {        
        this.resourceService.GetPolicyUrlByDocTypeId(policyTypeId.toString()).subscribe(res => {
            var wnd = window.open("about:blank", "", "_blank");
            wnd.document.write(res.toString());
        });
    };    

    getUserAgreements(currentUser) {
        this.resourceService.GetUserAgreements(currentUser.broker.Id).subscribe(
            result => {
                this.userAgreements = result;
                this.processUserAgreements();                
            }
        );
    };
    agreeCookiePolicy() {
        var cpAgreement = {};
        if (this.accountService.isLoggedIn()) {
            cpAgreement = this.userAgreements.find(function (agreement) { return agreement.DocumentTypeId === 3; });
        }
        else {
            cpAgreement = {
                DocumentTypeId: 3
            };
        }
        this.agreeToPolicy(cpAgreement);
    };

    agreeToPolicy(userAgreement) {
        switch (userAgreement.DocumentTypeId) {
            case 1:
                //ToS
                this.showTermsOfService = false;
                break;
            case 2:
                //Privacy
                this.showPrivacyPolicy = false;
                break;
            case 3:
                //Privacy
                this.setAgreeToCookiesLocal();
                break;
        }      
    }
    
    setAgreeToCookiesLocal() {
        this.showCookiePolicy = false;
        //$cookies.put(preFrameworkCookieFunctions.naiGDPRCookieName, new Date());
        this.cookieService.set(preFrameworkCookieFunctions.naiGDPRCookieName, new Date().toString());
        preFrameworkCookieFunctions.GAFrameworkIsDisabled(false);
       
    }

    processUserAgreements() {
        for (var agreement of this.userAgreements) {
            switch (agreement.DocumentTypeId) {
                case 1:
                    //ToS
                    if (agreement.AcceptedDate === '' || agreement.AcceptedDate === null) {

                        this.showTermsOfService = true;
                        this.resourceService.NotifyUserAgreement(agreement);
                    }
                    break;
                case 2:
                    //Privacy
                    if (agreement.AcceptedDate === '' || agreement.AcceptedDate === null) {

                        this.showPrivacyPolicy = true;
                        this.resourceService.NotifyUserAgreement(agreement);
                    }
                    break;
                case 3:
                    //Cookie
                    var localAgreedToCookies = preFrameworkCookieFunctions.hasAgreedToCookiePolicy();
                    var dbAgreedToCookies = (agreement.AcceptedDate !== '' && agreement.AcceptedDate !== null);
                    this.showCookiePolicy = !(localAgreedToCookies || dbAgreedToCookies);

                    if (this.showCookiePolicy) {
                        this.resourceService.NotifyUserAgreement(agreement);
                    }
                    else if (!(dbAgreedToCookies && localAgreedToCookies)) {
                        if (dbAgreedToCookies) {
                            this.setAgreeToCookiesLocal();
                        }
                        else if (localAgreedToCookies) {
                            this.validateLocalCookie(agreement);
                        }
                    }
                    break;
            }
        }        
    }
    validateLocalCookie(agreement) {
        this.resourceService.GetPolicyUpdateDate(3).subscribe(res => {
            var cookieDate = new Date(preFrameworkCookieFunctions.getCookie(preFrameworkCookieFunctions.naiGDPRCookieName));
            var policyDate = new Date(res.toString());
            if (policyDate > cookieDate) {
                //$cookies.remove(preFrameworkCookieFunctions.naiGDPRCookieName);
                this.cookieService.delete(preFrameworkCookieFunctions.naiGDPRCookieName);
                preFrameworkCookieFunctions.GAFrameworkIsDisabled(true);
                this.showCookiePolicy = true;
                this.resourceService.NotifyUserAgreement(agreement);
            }
            else {
                this.agreeToPolicy(agreement);
            }
        });           
    }
}
